import { render } from "./SlackChannelsListModal.vue?vue&type=template&id=11255c9d"
import script from "./SlackChannelsListModal.vue?vue&type=script&lang=js"
export * from "./SlackChannelsListModal.vue?vue&type=script&lang=js"
script.render = render

export default script